
import {addMinutes, subMinutes, isValid} from 'date-fns/esm'
import {timeToObject, timeToString, timeIsValid} from 'helpers/date'
import BaseModel from 'models/BaseModel'

export default class BaseStore extends BaseModel {

  // アクセサ: 店舗コードを取得
  get code() {
    return this.store_code
  }

  // アクセサ: 検索用キー値を取得
  get key() {
    return this.constructor.key(this)
  }

  // アクセサ: 表示用文字列
  get label() {
    return this.name + ' (' + this.floor_name + ')'
  }

  // アクセサ: 時間のバリデーション
  get isTimeValid() {
    return timeIsValid(this.begin_time, this.end_time)
  }

  // アクセサ: 開店時間の何時間前から扱うか
  get display_begin_time() {
    const time = timeToObject(this.begin_time)
    return isValid(time) ? timeToString(subMinutes(time, 1)) : '' // 開店1時間前
  }

  // アクセサ: 閉店時間の何時間後まで扱うか
  get display_end_time() {
    const time = timeToObject(this.end_time)
    return isValid(time) ? timeToString(addMinutes(time, 1)) : '' // 閉店1時間後
  }
}
